<div class="snack-container">
    <div class="kt-block-inline">
        <!-- <mat-icon>{{getIcon}}</mat-icon> -->
    </div>
    <div class="kt-block-inline" >
        <span>{{data.message}}</span>
    </div>
</div>